import React from 'react'
import { Banner } from '@workspace/frontend-kit'
import clsx from 'clsx'
import TokTokDocDialog from '../Dialog'
import LargeSwitch from '../largeSwitch/LargeSwitch'
import useStyles from './_styles'
import type { SwitchConfirmDialogProps } from './_props'

const SwitchConfirmDialog: React.FC<SwitchConfirmDialogProps> = ({
    title,
    bannerText,
    bannerTitle,
    switchText,
    submitText,
    isLoading = false,
    onApprove,
    onCancel,
    saveStartIcon,
    submitBackgroundColor,
}) => {
    const style = useStyles()
    const [userConfirmed, setUserConfirmed] = React.useState(false)

    const handleUserConfirm = () => setUserConfirmed((previousValue) => !previousValue)

    const buttonOptions = {
        colors: {
            save: submitBackgroundColor,
        },
    }

    return (
        <TokTokDocDialog
            title={title}
            saveTitle={submitText}
            handleSave={onApprove}
            handleCancel={onCancel}
            handleClose={onCancel}
            isOpen
            disableCondition={!userConfirmed}
            saveStartIcon={saveStartIcon}
            buttonsOptions={buttonOptions}
            loading={isLoading}
            dialogProps={{
                disableRestoreFocus: true,
            }}
        >
            <div className={clsx(style.Wrapper)}>
                <Banner title={bannerTitle} text={bannerText} severity="WARNING" />
                <LargeSwitch label={switchText} onChange={handleUserConfirm} />
            </div>
        </TokTokDocDialog>
    )
}

export default SwitchConfirmDialog
